import { EmptyStateProps } from './interface';
import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '../Typography/LegacyTypography/Typography.web';

export const EmptyState = ({ title, description }: EmptyStateProps) => {
  return (
    <Box mt={3} mb={2} textAlign="center">
      <Box mb={0.5}>
        <Typography variant="label" size="m">
          {title}
        </Typography>
      </Box>
      <Typography>{description}</Typography>
    </Box>
  );
};
